import { Component, input, Input, OnInit, output } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  AwFormFieldLabelComponent,
  AwFormMessageComponent,
  AwSelectMenuComponent,
  SingleSelectOption,
} from '@assetworks-llc/aw-component-lib';

@Component({
  selector: 'app-aw-dropdown-form',
  imports: [
    ReactiveFormsModule,
    AwFormFieldLabelComponent,
    AwFormMessageComponent,
    AwSelectMenuComponent,
  ],
  templateUrl: './aw-dropdown-form.component.html',
  styleUrl: './aw-dropdown-form.component.scss',
  standalone: true,
})
export class AwDropdownFormComponent implements OnInit {
  options = input<SingleSelectOption[]>([]);
  title = input<string>('');
  required = input<boolean>(true);
  label = input<string | null>('');

  currentOption = output<SingleSelectOption | null>();

  selectDropdownForm!: FormGroup;
  ngOnInit(): void {
    this.selectDropdownForm = new FormGroup({
      selectOption: new FormControl<any>(this.label(), [Validators.required]),
    });
    this.selectDropdownForm.controls['selectOption'].valueChanges.subscribe(
      (option) => {
        this.currentOption.emit(option);
      }
    );
  }
}
